import { showToast } from "@cerebruminc/cerebellum";

/**
 * method to show success toast message
 * @param text message string
 */
export const showSuccess = (text: string) => {
	showToast({
		id: `success-toast-${Date.now()}`,
		message: text,
		tone: "positive",
	});
};
